import orderOptimizerTranslationsHelper from "../../../../../../../languages/order-optimizer-translations.helper";
import OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesDriverTableColumn from "../types/order-optimizer-taxi-details-hidden-details-heading-tables-driver-table-column";

const getColumns =
  (): OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesDriverTableColumn[] => {
    const translations =
      orderOptimizerTranslationsHelper.getTaxiDetailsTranslations().table
        .headingTables.driver;

    const tableColumns: OrderOptimizerTaxiDetailsHiddenDetailsHeadingTablesDriverTableColumn[] =
      [
        {
          header: translations.totalTimeLabel,
          title: translations.totalTimeTitle,
          accessor: "totalTime",
          colSpan: 3,
        },
        {
          header: translations.haltingTimeLabel,
          title: translations.haltingTimeTitle,
          accessor: "haltingTime",
          colSpan: 3,
        },
        {
          header: translations.totalDrivingTimeLabel,
          title: translations.totalDrivingTimeTitle,
          accessor: "totalDrivingTime",
          colSpan: 3,
        },
        {
          header: translations.distanceLabel,
          title: translations.distanceTitle,
          accessor: "distance",
          colSpan: 3,
        },
      ];

    return tableColumns;
  };

const orderOptimizerTaxiDetailsHiddenDetailsHeadingTablesDriverTableHelper = {
  getColumns,
};

export default orderOptimizerTaxiDetailsHiddenDetailsHeadingTablesDriverTableHelper;
